import { buildModelManager } from "../builder.js";
const DefaultExternalCalendarFeedSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  deletedAt: true,
  enabled: true,
  label: true,
  lastPollError: true,
  lastPolledAt: true,
  lastPolledEvents: true,
  membershipId: true,
  profileId: true,
  updatedAt: true,
  url: true
};
const modelApiIdentifier = "externalCalendarFeed";
const pluralModelApiIdentifier = "externalCalendarFeeds";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultExternalCalendarFeedSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultExternalCalendarFeedSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultExternalCalendarFeedSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultExternalCalendarFeedSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultExternalCalendarFeedSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultExternalCalendarFeedSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultExternalCalendarFeedSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createExternalCalendarFeed",
    operationReturnType: "CreateExternalCalendarFeed",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      externalCalendarFeed: { required: false, type: "CreateExternalCalendarFeedInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultExternalCalendarFeedSelection
  },
  {
    type: "action",
    operationName: "bulkCreateExternalCalendarFeeds",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateExternalCalendarFeedsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultExternalCalendarFeedSelection
  },
  {
    type: "action",
    operationName: "updateExternalCalendarFeed",
    operationReturnType: "UpdateExternalCalendarFeed",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      externalCalendarFeed: { required: false, type: "UpdateExternalCalendarFeedInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultExternalCalendarFeedSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateExternalCalendarFeeds",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateExternalCalendarFeedsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultExternalCalendarFeedSelection
  },
  {
    type: "action",
    operationName: "deleteExternalCalendarFeed",
    operationReturnType: "DeleteExternalCalendarFeed",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteExternalCalendarFeeds",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "restoreExternalCalendarFeed",
    operationReturnType: "RestoreExternalCalendarFeed",
    functionName: "restore",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      externalCalendarFeed: { required: false, type: "RestoreExternalCalendarFeedInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultExternalCalendarFeedSelection
  },
  {
    type: "action",
    operationName: "bulkRestoreExternalCalendarFeeds",
    functionName: "bulkRestore",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "restore",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkRestoreExternalCalendarFeedsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultExternalCalendarFeedSelection
  },
  {
    type: "action",
    operationName: "upsertExternalCalendarFeed",
    operationReturnType: "UpsertExternalCalendarFeed",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      externalCalendarFeed: { required: false, type: "UpsertExternalCalendarFeedInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateExternalCalendarFeedResult": { hasReturnType: false },
      "... on UpdateExternalCalendarFeedResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultExternalCalendarFeedSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertExternalCalendarFeeds",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertExternalCalendarFeedsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultExternalCalendarFeedSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "externalCalendarFeedGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ExternalCalendarFeedManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultExternalCalendarFeedSelection,
  operations
);
export {
  DefaultExternalCalendarFeedSelection,
  ExternalCalendarFeedManager
};
//# sourceMappingURL=ExternalCalendarFeed.js.map
